import { CommonModule, NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconComponent } from '@shared/src/lib/components/icon/icon.component';
import { SideNavigation } from '@shared/src/lib/components/side-navigation/side-navigation.interface';
import { PetronasIconComponent } from '@shared/src/lib/icons/petronas-icon/petronas-icon.component';
import { FilterVisiblePipe } from '@shared/src/lib/components/pipes/visibleSelection.pipe';

@Component({
  selector: 'lib-side-navigation',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    NgFor,
    IconComponent,
    PetronasIconComponent,
    FilterVisiblePipe,
  ],
  templateUrl: './side-navigation.component.html',
  styleUrl: './side-navigation.component.css',
})
export class SideNavigationComponent {
  @Input() items: SideNavigation.Item[];
}
